import { FilterOption } from '~/app/features/Gallery/components/Filters/FilterOption'
import { MultiSelectFilter } from '~/app/features/Gallery/components/Filters/MultiSelect'
import type { State } from 'shared/types/gallery/state'
import type { RenderableFilterOption } from 'shared/types/util'

interface PropTypes {
  filter: State.Filter
}

export const CheckboxFilter = (props: PropTypes) => {
  const { filter } = props

  return (
    <MultiSelectFilter filter={filter as State.AttributeFilter}>
      {(o: RenderableFilterOption) => <FilterOption facetCount={o.facetCount} title={o.title} />}
    </MultiSelectFilter>
  )
}

CheckboxFilter.displayName = 'CheckboxFilter'
